import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'

if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_MSW_DISABLED === 'false') {
  const { worker } = await import('./mocks/config/browser')
  worker.start()
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
    <App />
)
